import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'
import type { TUnitConverterTypicalReturn } from '../types'

const plantWaterStress = (
  value: number | null = null,
  {
    decimalPlaces,
  }: {
    decimalPlaces?: number
  } = {},
): TUnitConverterTypicalReturn => {
  const defaultNumberOfDecimalPlaces = 2
  const decimalPlacesToUse = decimalPlaces ?? defaultNumberOfDecimalPlaces

  return {
    categoryTitle: () => {
      return translate.phrases.banyanApp('Plant Water Stress')
    },
    categoryTitleWithoutUnit: () => {
      return translate.phrases.banyanApp('Plant Water Stress')
    },
    defaultNumberOfDecimalPlaces: () => defaultNumberOfDecimalPlaces,
    suffix: () => '',
    shortTitle: () => {
      return translate.phrases.banyanApp('Plant Water Stress')
    },
    title: () => {
      return translate.phrases.banyanApp('Plant Water Stress')
    },
    titleWithoutUnit: () => {
      return translate.phrases.banyanApp('Plant Water Stress')
    },
    value: () => {
      if (isNil(value)) return null

      return +value?.toFixed(decimalPlacesToUse)
    },
    valueAsString: () => {
      if (isNil(value)) return translate.phrases.templates('-')
      else return value.toFixed(decimalPlacesToUse)
    },
    valueWithSuffix: () => {
      if (isNil(value)) return translate.phrases.templates('-')
      else return value.toFixed(decimalPlacesToUse)
    },
    valueWithNoRounding: () => value,
  }
}

const trunkDisplacement = (
  value: number | null = null,
  {
    decimalPlaces,
  }: {
    decimalPlaces?: number
  } = {},
): TUnitConverterTypicalReturn => {
  const defaultNumberOfDecimalPlaces = 0
  const decimalPlacesToUse = decimalPlaces ?? defaultNumberOfDecimalPlaces
  const unitSymbol = translate.measurements.micrometers.unit()

  return {
    categoryTitle: () => {
      return translate.phrases.banyanApp('Trunk Displacement')
    },
    categoryTitleWithoutUnit: () => {
      return translate.phrases.banyanApp('Trunk Displacement')
    },
    defaultNumberOfDecimalPlaces: () => defaultNumberOfDecimalPlaces,
    suffix: () => unitSymbol,
    shortTitle: () => {
      return translate.phrases.banyanApp('Trunk Displacement')
    },
    title: () => {
      return translate.phrases.templates('{{label}} ({{unitSymbol}})', {
        label: translate.phrases.banyanApp('Trunk Displacement'),
        unitSymbol,
      })
    },
    titleWithoutUnit: () => {
      return translate.phrases.banyanApp('Trunk Displacement')
    },
    value: () => {
      if (isNil(value)) return null

      return +value?.toFixed(decimalPlacesToUse)
    },
    valueAsString: () => {
      return translate.measurements.micrometers.value(value, decimalPlacesToUse)
    },
    valueWithSuffix: () => {
      return translate.measurements.micrometers.valueWithUnit(value, decimalPlacesToUse)
    },
    valueWithNoRounding: () => value,
  }
}

export const plantStress = {
  plantWaterStress,
  trunkDisplacement,
}
